// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"c8285a71","880":"b78ad41a"}[chunkId] + ".chunk.js";
};